import React, { useState } from 'react';
import { 
  Box, 
  // Checkbox, 
  Collapse, 
  IconButton, 
  makeStyles, 
  Table, 
  TableCell, 
  TableHead, 
  TableRow, 
  Typography 
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import IconEstado from '../../../autorizaciones/UI/IconEstado';
import { 
  // AUTORIZACIONES_PRACTICAS_ESTADOS, 
  // AUTORIZACIONES_SOLICITUDES_ESTADOS, 
  TIPOS_AUTORIZACIONES 
} from '../../../../utils/constants';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
    backgroundColor: 'lightgray',
  },
});

export const PracticaItemLaboratorio = (props) => {
  const classes = useRowStyles();
  
  const { item, /* estadoSolicitud, */ idTipoSolicitud } = props;
  
  const [open, setOpen] = useState(false);
  // const [checkbox, setCheckbox] = useState(false);
  
  return (
    <>
      <TableRow className={classes.root}>
        {/* <TableCell align="left">
          <Checkbox
            checked={checkbox}
            name={`solicitud-${item.idSolicitud}/practica-${item.idCodNom}`}
            onChange={(e) => setCheckbox(e.target.checked)}
            disabled={item.idEstadoPractica !== AUTORIZACIONES_PRACTICAS_ESTADOS.AUTORIZADO
              || estadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA
            }            
          />
        </TableCell> */}
        <TableCell component="th" scope="row">
          <IconEstado
            useColorTable={true}
            texto={item?.estadoPracticaSolicitud?.letra}
            backgroundColor={item?.estadoPracticaSolicitud?.color}
            descripcion={item?.estadoPracticaSolicitud?.descripcionEstado}
          />
        </TableCell>
        <TableCell component="th" scope="row">
          {item.practica?.desNom}
        </TableCell>
        <TableCell align="right">{item.cant}</TableCell>
        <TableCell align="center">{item.recuperoSur ? 'SI' : 'NO'}</TableCell>
        <TableCell>
          {item.materiales.length > 0 &&
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          }
        </TableCell>
        <TableCell>
          {item.cartillaPrestadores?.atiendeCentroPropio
            ? item.cartillaPrestadores?.centroMedicoPropio.descripcionCentro
            : props.idPrestacion
              ? item.efectorProfesional?.nombreApellido
              : item.cartillaPrestadores
                ? item.cartillaPrestadores?.prestador?.nombreApellido
                : item.efectorFacturacion?.nombreFantasia

          }
        </TableCell>
        {(props.conInternacion || props.idPrestacion) &&
          <TableCell>{item.efectorProfesional?.nombreApellido}</TableCell>
        }
      </TableRow>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 50 }} colSpan={6}>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Materiales
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Estado Material</TableCell>
                    {idTipoSolicitud === TIPOS_AUTORIZACIONES.PRACTICAS_EN_INTERNACION &&  <TableCell>Estado Compra</TableCell>}
                    <TableCell>Material</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell align="center">SURGE</TableCell>
                    <TableCell align="center">Disponible</TableCell>

                  </TableRow>
                </TableHead>
                <br></br>
              </Table>
            </Box>
            <Box>
            </Box>
          </TableCell>
        </TableRow>
      </Collapse>
    </>
  );
}

